/**
 * Canonical fallback node dimensions.
 *
 * These are the geometry the layout engine assumes when a node carries no
 * usable `layoutSize` — legacy documents, imports, and nodes that have not
 * been measured yet. They feed placement, collision, viewport culling,
 * spatial navigation, and obstacle routing, so an inaccurate value is not a
 * cosmetic default: an over-stated rectangle manufactures node overlaps that
 * never appear on screen, and those overlaps switch obstacle routing off for
 * the connections attached to them.
 *
 * Measured against the rendered client (12px text, 14.4px line box, 8px
 * padding, 238px maximum content width):
 *
 *   one line ...... 34px tall
 *   two lines ..... ~48px tall
 *   171 characters  74px tall
 *   widest node ... 254px (238px content + 16px padding)
 *
 * The height therefore sits just above a single line rather than at the
 * previous 110px, which exceeded even a six-line node by half again.
 */
export const DEFAULT_NODE_SIZE = Object.freeze({ width: 260, height: 44 });

/**
 * The compact footprint of a freshly created, still-empty idea.
 */
export const DEFAULT_NEW_NODE_SIZE = Object.freeze({ width: 96, height: 44 });
